<template>
  <div class="sales-index">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>销售工作台</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="商户类型:">
        <el-select
          size="small"
          v-model="formInline.agentType"
          placeholder="全部"
        >
          <el-option
            v-for="(val, index) in merchantTypeList"
            :label="val.label"
            :value="val.value"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商户:">
        <el-select
          size="small"
          v-model="formInline.merchantName"
          filterable
          allow-create
          default-first-option
          placeholder="请选择或输入商户名称"
          @blur="selectMerchantNameBlur"
        >
          <el-option
            v-for="(val, index) in merchantList"
            :label="val"
            :value="val"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务商:">
        <el-select
          size="small"
          v-model="formInline.disCompanyName"
          filterable
          allow-create
          default-first-option
          placeholder="请选择或输入服务商名称"
          @blur="selectDisCompanyBlur"
        >
          <el-option
            v-for="(val, index) in disCompanyList"
            :label="val.label"
            :value="val.label"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间范围: ">
        <el-date-picker
          size="small"
          v-model="formInline.date"
          type="daterange"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" icon="el-icon-refresh-left" @click="reset">清空</el-button>
      </el-form-item>
    </el-form>

    <!-- 快捷入口 -->
    <div class="quick-entries">
      <span class="quick-entries-label">快捷入口：</span>
      <el-button type="text" icon="el-icon-s-data" @click="jumpToPage('/sales/salesBatchStatistics')">批次统计</el-button>
      <el-button type="text" icon="el-icon-s-marketing" @click="jumpToPage('/sales/salesMerchantStatistics')">商户统计</el-button>
      <el-button type="text" icon="el-icon-s-marketing" @click="jumpToPage('/sales/allCustomersMonthlyFlow')">月度流水</el-button>
      <el-button type="text" icon="el-icon-s-custom" @click="jumpToPage('/sales/merchantList')">商户列表</el-button>
    </div>

    <div class="dashboard-container">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="card-wrapper">
            <el-card class="box-card stat-card stat-card--merchant" shadow="hover">
              <div slot="header" class="clearfix header-title">
                <i class="el-icon-s-custom header-icon"></i>
                <span>客户数量</span>
              </div>
              <div class="merchants">
                <div class="stat-value-wrap" v-loading="loading">
                  <span class="count">{{ partnerMerchantNum }}</span>
                </div>
                <p class="stat-label"><span>合作商户数</span></p>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="card-wrapper">
            <el-card class="box-card stat-card stat-card--recharge" shadow="hover">
              <div slot="header" class="clearfix header-title">
                <i class="el-icon-coin header-icon"></i>
                <span>流水（元）</span>
              </div>
              <div class="total-disbursement">
                <div class="stat-value-wrap" v-loading="loading">
                  <span class="amount">{{ formatAmount(totalPreTaxAmount) }}</span>
                </div>
                <p class="stat-label"><span>税前金额</span></p>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="card-wrapper">
            <el-card class="box-card stat-card stat-card--disburse" shadow="hover">
              <div slot="header" class="clearfix header-title">
                <i class="el-icon-money header-icon"></i>
                <span>毛利（元）</span>
              </div>

              <div class="total-disbursement">
                <div class="stat-value-wrap" v-loading="loading">
                  <span class="amount">{{ formatAmount(totalGrossProfit) }}</span>
                </div>
                <p class="stat-label"><span>总毛利</span></p>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  getSalesStatisticsData,
  getSalesMerchantName,
  getDisCompanyNames,
} from "../../api/userMG";
export default {
  name: "index-sales",
  components: {
    // "notice-list": noticeList,
  },

  data() {
    return {
      loading: false,
      partnerMerchantNum: 0,
      totalPreTaxAmount: "0.00",
      totalGrossProfit: "0.00",
      merchantList: [],
      disCompanyList: [],
      merchantTypeList: [
        {
          label: "普通商户",
          value: 1,
        },
        {
          label: "代理商户",
          value: 2,
        },
      ],
      formInline: {
        disCompanyName: "",
        merchantName: "",
        startDate: "",
        endDate: "",
        agentType: "",
        date: [],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },

  created() {
    getSalesMerchantName({
      page: 1,
      pageSize: 9999,
    })
      .then((res) => {
        if (res.msg == "success") {
          this.merchantList = res.data.items;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      })
      .catch((err) => {});

    // 服务商
    getDisCompanyNames({
      page: 1,
      pageSize: 9999,
      type: 2,
    })
      .then((res) => {
        if (res.msg == "success") {
          this.disCompanyList = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      })
      .catch((err) => {});
  },

  mounted() {
    // 处理日期范围
    if (this.formInline.date && this.formInline.date.length === 2) {
      this.formInline.startDate = this.formInline.date[0] || "";
      this.formInline.endDate = this.formInline.date[1] || "";
    } else {
      this.formInline.startDate = "";
      this.formInline.endDate = "";
    }
    this.getdata(this.formInline);
  },

  watch: {
    "formInline.agentType": function (newVal) {
      let params = {
        agentType: newVal,
        page: 1,
        pageSize: 9999,
      };

      getSalesMerchantName(params)
        .then((res) => {
          if (res.msg == "success") {
            this.merchantList = res.data.items;
            this.formInline.merchantName = "";
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
  },

  methods: {
    // 金额千分位格式化，保留两位小数
    formatAmount(val) {
      if (val === null || val === undefined || val === "") return "0.00";
      const num = Number(val);
      if (isNaN(num)) return String(val);
      return num.toLocaleString("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    jumpToPage(path) {
      this.$router.push({ path });
    },

    getdata(formInline) {
      this.loading = true;
      const params = {
        merchantName: formInline.merchantName,
        disCompanyName: formInline.disCompanyName,
        startDate: formInline.startDate,
        endDate: formInline.endDate,
        agentType: formInline.agentType,
      };
      getSalesStatisticsData(params)
        .then((res) => {
          if (res.msg == "success") {
            this.partnerMerchantNum = res.data.partnerMerchantNum;
            this.totalPreTaxAmount = res.data.totalPreTaxAmount;
            this.totalGrossProfit = res.data.totalGrossProfit;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    search() {
      if (this.formInline.date && this.formInline.date.length === 2) {
        this.formInline.startDate = this.formInline.date[0] || "";
        this.formInline.endDate = this.formInline.date[1] || "";
      } else {
        this.formInline.startDate = "";
        this.formInline.endDate = "";
      }
      this.getdata(this.formInline);
    },

    reset() {
      this.formInline = {
        disCompanyName: "",
        merchantName: "",
        startDate: "",
        endDate: "",
        agentType: "",
        date: [],
      };
      this.getdata(this.formInline);
    },
    selectMerchantNameBlur(e) {
      this.formInline.merchantName = e.target.value;
    },
    selectDisCompanyBlur(e) {
      this.formInline.disCompanyName = e.target.value;
    },
  },

  beforeDestroy() {
    // console.log("商户 beforeDestroy");
  },

  destroyed() {},
};
</script>

<style scoped>
.sales-index {
  padding-bottom: 24px;
}

.user-search {
  margin-top: 24px;
  margin-bottom: 16px;
  padding: 16px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.el-form-item {
  margin-bottom: 16px !important;
}

.quick-entries {
  margin-bottom: 20px;
  padding: 12px 16px;
  background: #f4f4f5;
  border-radius: 4px;
  font-size: 13px;
}

.quick-entries-label {
  color: #606266;
  margin-right: 8px;
}

.quick-entries .el-button--text {
  margin-right: 16px;
  padding: 0 4px;
}

.dashboard-container {
  min-height: 200px;
}

.stat-value-wrap {
  min-height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box-card {
  min-height: 160px;
  text-align: center;
  border-radius: 6px;
}

.box-card >>> .el-card__header {
  padding: 14px 20px;
  font-size: 15px;
}

.box-card >>> .el-card__body {
  padding: 20px;
}

.clearfix::after {
  content: "";
  display: block;
  clear: both;
}

.header-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.header-title span {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.header-icon {
  font-size: 20px;
  color: #909399;
}

.stat-card--merchant .header-icon {
  color: #409eff;
}

.stat-card--recharge .header-icon {
  color: #67c23a;
}

.stat-card--disburse .header-icon {
  color: #e6a23c;
}

.card-wrapper {
  margin-top: 20px;
}

.task-status,
.service-fees {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.task-status .status-item,
.service-fees .fee-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 20px;
}

.task-status .total-tasks {
  font-size: 26px;
  color: #409eff;
}

.task-status .incomplete-tasks {
  font-size: 26px;
  color: #f56c6c;
}

.task-status .pending-invoice {
  font-size: 26px;
  color: #e6a23c;
}

.task-status .completed-tasks {
  font-size: 26px;
  color: #67c23a;
}

.stat-label {
  margin: 8px 0 0;
  font-size: 13px;
  color: #909399;
}

.fee-item .zero-work-costs,
.fee-item .service-costs {
  font-size: 22px;
  font-weight: 500;
}

.fee-item .zero-work-costs {
  color: #606266;
}

.fee-item .service-costs {
  color: #909399;
}

.total-disbursement .amount,
.merchants .count {
  font-size: 28px;
  font-weight: 600;
}

.merchants .count {
  color: #409eff;
}

.total-disbursement .amount {
  color: #67c23a;
}
</style>


// WEBPACK FOOTER //
// src/views/sales/index.vue